/*
  Accordion deep-link/anchor handling — extracted from snippets/accordion.liquid so it ships
  from a cacheable, deferred asset instead of inline markup.

  The snippet renders once per accordion, so the same <script src> can appear several times on a
  page; the __accordionAnchorsInit guard keeps the DOMContentLoaded listener registered once.
*/
if (!window.__accordionAnchorsInit) {
  window.__accordionAnchorsInit = true;

  window.addEventListener("DOMContentLoaded", () => {
      const isMobile = window.innerWidth <= 768; // Detect if the device is mobile

      // Function to highlight and open the active accordion item
      function openAccordionItem(targetElement) {
          const accordionItem = targetElement.closest('details');

          if (accordionItem) {
              // Open the accordion if it's not already open
              accordionItem.setAttribute('open', true);
              accordionItem.classList.add('is-open'); // Add a class to indicate it's open

              // Show the content of the accordion
              const contentPanel = accordionItem.querySelector('.cc-accordion-item__panel');
              if (contentPanel) {
                  contentPanel.style.display = 'block';
              }
          }
      }

      const urlHash = window.location.hash;
      if (urlHash) {
          const targetElement = document.querySelector(decodeURI(urlHash));
          if (targetElement) {
              const offset = 110; // Adjust offset for both desktop and mobile

              // Let the browser scroll to the anchor, then correct the scroll position
              setTimeout(() => {
                  var targetOffset = targetElement.getBoundingClientRect().top + window.scrollY;

                  // Correct the scroll position with the offset
                  window.scrollTo({
                      top: targetOffset - offset,
                      behavior: 'auto' // Instant scroll to avoid visible jumps
                  });

                  // Highlight and open the active accordion item
                  openAccordionItem(targetElement);

                  // Final check after a short delay to correct the offset if needed (e.g., after images load)
                  setTimeout(() => {
                      var finalOffset = targetElement.getBoundingClientRect().top + window.scrollY;
                      window.scrollTo({
                          top: finalOffset - offset,
                          behavior: 'auto' // Adjust with no smooth scroll for final positioning
                      });
                  }, 300); // Adjust this delay if necessary (300ms should handle most cases)

              }, 0); // Adjust immediately after the browser scrolls
          }
      }
  });
}
